export const CANCEL_REASONS = [
  { value: 'I don’t understand how to use your product', label: 'I don’t understand how to use your product' },
  { value: 'It’s too expensive', label: 'It’s too expensive' },
  { value: 'I found another product that I like better', label: 'I found another product that I like better' },
  { value: 'I don’t use it enough', label: 'I don’t use it enough' },
  { value: 'Some features I need are missing', label: 'Some features I need are missing' },
  { value: 'Not realizing the value proposition', label: 'Not realizing the value proposition' },
  { value: 'Poor customer support', label: 'Poor customer support' },
  { value: 'Others', label: 'Others (Please Specify)' }
]

export const PAYMENT_GATEWAY_OPTIONS = [
  { value: 'PayPal', label: 'PayPal' },
  { value: 'Stripe', label: 'Stripe' },
  { value: 'Paytm', label: 'Paytm' },
  { value: 'GPay', label: 'GPay' },
  { value: 'Others', label: 'Others' },
]